import { AvatarSize, Box, Text } from '@bechtel/gds';
import { useName } from '@bechtel/ht-clients-common';
import { FC } from 'react';
import UserPhoto from '~/components/molecules/user-photo';
import { UserItemStyled } from './styled';
import { UserCardProps } from './types';

const UserCard: FC<UserCardProps> = ({ userItem }) => {
  const { getFullName } = useName();
  return (
    <UserItemStyled justifyContent={{ sm: 'space-between' }}>
      <Box>
        <Box mr={{ sm: '500' }}>
          <UserPhoto user={userItem} imageUrl={userItem.employee?.imageUrl || ''} size={AvatarSize.MEDIUM}></UserPhoto>
        </Box>
        <Box flexDirection={{ sm: 'column' }}>
          <Box pt={{ sm: '100' }} pb={{ sm: '200' }} style={{ whiteSpace: 'nowrap' }}>
            <Text size="400" color="primary.700" weight="600">
              {getFullName(userItem.firstName, userItem.lastName)}
            </Text>
          </Box>
          <Box pb={{ sm: '200' }}>
            <Text size="200" color="grey.600">
              {userItem.bun}
            </Text>
          </Box>
        </Box>
      </Box>
      <Box>
        <Text size="200" color="grey.600">
          {userItem?.employee?.persona || 'User'}
        </Text>
      </Box>
    </UserItemStyled>
  );
};

export default UserCard;
